import { Maybe } from 'graphql/jsutils/Maybe';

const formatMonths = (months: number): string => `${months} months`;
const formatYears = (months: number): string => `${Math.floor(months / 12)} years`;
const formatYearsWithPlus = (months: number): string => `${Math.floor(months / 12)}+ years`;

export const activityAgesToRangeText = (
  minAgeMonths?: Maybe<number>,
  maxAgeMonths?: Maybe<number>
): string | null => {
  // Number of months for 18 years + 1day;
  const GROWN_THRESHOLD = 18 * 12 + 1;
  const maxAge = (maxAgeMonths ?? 0) >= GROWN_THRESHOLD ? 0 : maxAgeMonths;

  if (!minAgeMonths && !maxAge) {
    return 'All ages';
  }

  if (!maxAge) {
    return minAgeMonths! < 12 ? `${minAgeMonths}+ months` : formatYearsWithPlus(minAgeMonths!);
  }

  if (!minAgeMonths) {
    return maxAge <= 12 ? `Up to ${formatMonths(maxAge)}` : `Up to ${formatYears(maxAge)}`;
  }

  if (minAgeMonths === maxAge) {
    return minAgeMonths < 12 ? formatMonths(minAgeMonths) : formatYears(minAgeMonths);
  }

  const minInYears = Math.floor(minAgeMonths / 12);
  const maxInYears = Math.floor(maxAge / 12);

  if (minAgeMonths < 12 && maxAge < 12) {
    return `Ages ${minAgeMonths}-${maxAge} months`;
  }

  if (minAgeMonths < 12) {
    return `${formatMonths(minAgeMonths)} - ${formatYears(maxAge)}`;
  }

  return `Ages ${minInYears}-${maxInYears} years`;
};
